import request from '@/utils/request'


// 查询成长值流水列表
export function listGrowthLog(query) {
  return request({
    url: '/biz/admin/user/growth/log/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询成长值流水分页
export function pageGrowthLog(query) {
  return request({
    url: '/biz/admin/user/growth/log/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询成长值流水详细
export function getGrowthLog(data) {
  return request({
    url: '/biz/admin/user/growth/log/detail',
    method: 'get',
    params: data
  })
}

// 新增成长值流水
export function addGrowthLog(data) {
  return request({
    url: '/biz/admin/user/growth/log/add',
    method: 'post',
    data: data
  })
}

// 修改成长值流水
export function updateGrowthLog(data) {
  return request({
    url: '/biz/admin/user/growth/log/edit',
    method: 'post',
    data: data
  })
}

// 删除成长值流水
export function delGrowthLog(data) {
  return request({
    url: '/biz/admin/user/growth/log/delete',
    method: 'post',
    data: data
  })
}
